// Countdown Timer Bar
class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.settings = JSON.parse(this.dataset.settings);

    this.selectors = {
      numberContainer: '.countdown-timer__number-container',
    };

    this.clockElements = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };

    this.eventDate = new Date(this.settings['date']);

    this.updateGetTime(this.eventDate);
    this.updateClock = setInterval(this.updateGetTime.bind(this), 1000);
  }

  validateTime(distance) {
    if (distance > 0 && !isNaN(distance)) return;
    // Stop timer if time is invalid
    clearInterval(this.updateClock);
  }

  updateGetTime() {
    // Calculate the current time based on the initial timestamp
    const initialTime = new Date(window.theme.time);
    const elapsedTime = Date.now() - initialTime.getTime();
    const now = new Date(initialTime.getTime() + elapsedTime);

    // Calculate the distance between now and the event date
    const nowTime = now.getTime();
    const event = new Date(this.eventDate).getTime();
    const distance = event - nowTime;

    this.validateTime(distance);

    const time = {
      days: Math.floor(distance / (1000 * 60 * 60 * 24)),
      hours: Math.floor((distance / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((distance / (1000 * 60)) % 60),
      seconds: Math.floor((distance / 1000) % 60),
    };

    this.updateClockEl(time);
  }

  updateClockEl(time) {
    Object.keys(time).forEach((key) => {
      let number = time[key] <= 0 || isNaN(time[key]) ? '00' : time[key].toString().padStart(2, '0');
      const dateElement = this.clockElements[key];
      if (!dateElement) return;
      dateElement.innerHTML = number;
    });
  }
}

function initCountdownTimer() {
  customElements.define('countdown-timer', CountdownTimer);
}

export default initCountdownTimer;
